//testing department wise
import React, { useEffect, useMemo, useState } from "react";
import ContentHeader from "../../components/ContentHeader";
import { FiPlusCircle } from "react-icons/fi";
import SearchFilter from "../../components/SearchFilter";
import { Table, Space, Pagination, Button, Popconfirm, message } from "antd";
import { statusOptions, sourceOptions, departmentOptions } from "./constants";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { BiSolidPhoneCall } from "react-icons/bi";
import ReopenLead from "./ReopenLead";
import TeamLeadService from "../../services/TeamLead.services";

import {
  EditOutlined,
  EyeOutlined,
  LockOutlined,
  DeleteOutlined,
  UserOutlined,
  GoldOutlined,
  ReconciliationFilled,
} from "@ant-design/icons";
import localStorageContent from "../../utils/localstorage";
import { extractTextFromHTML, getLeadStatus } from "../../utils";
import reportsService from "../../services/Reports.services";
import TeamService from "../../services/Team.services";
import History from "../../components/History";
import { setError } from "../../store/reducers";
import DownloadCsv from "../../utils/downloadCSV";
import DashboardService from "../../services/Dashboard.services";
import LeadHistory from "../../components/LeadHistory";
import Checkbox from "antd/es/checkbox/Checkbox";
import LeadService from "../../services/Lead.services";

const Reports = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [checkedReopenLead, setCheckedReOpenLead] = useState<boolean>(false);
  const [reportsList, setReportsList] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [teamList, setTeamList] = useState<any[]>([]);
  const [tableColumns, setTableColumns] = useState<any[]>([]);
  const [currentLeadId, setCurrentLeadId] = useState<any>(null);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showModalName, setIsShowModalName] = useState<boolean>(false);
  const [isSearched, setIsSearched] = useState<boolean>(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [queryString, setQueryString] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [dataLoaded, setDataLoaded] = useState<boolean>(false); // Add this state
  const [teamDataLoaded, setTeamDataLoaded] = useState<boolean>(false);
  const localUserData = localStorageContent.getUserData();
  const multiDep = localStorageContent.getMultiDepartment();
  const { getreportsList } = reportsService;
  const { getTeamList, filterTeamLeadByDept } = TeamService;
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [leadList, setLeadList] = useState<any[]>([]);
  const { getleadList, deleteLead } = LeadService;
  const [isTeamDropdownDisabled, setIsTeamDropdownDisabled] = useState(true);

  const { getTeamLeadList, getTeamLead, getTeamLeadSearchDropdownList } =
    TeamLeadService;
  const [teamLeadList, setTeamLeadList] = useState<any[]>([]);

  const toggleReopenLeadCheckbox = (checked: boolean, lead_id: any) => {
    setCheckedReOpenLead(checked);
    setSelectedLeadId(lead_id);
  };

  const LoadLeadList = async () => {
    const response = await getTeamLeadSearchDropdownList();
    if (response && response?.data?.length > 0) {
      const Leads: any = [];
      response?.data?.map((team: any) => {
        Leads.push({
          label: team?.first_name + " " + team?.last_name,
          value: team.user_id,
        });
      });
      setLeadList(Leads);
    } else {
      setLeadList([]);
    }
  };

  const { getDashboardLeadwiseWiseteammembersDetails } = DashboardService;

  const exportFormates: any = {
    updated_dt: (value: any) =>
      value ? `${new Date(value).toLocaleDateString()}` : "",
    lead_id: (value: any) => (value ? `Lead #${value}}` : ""),
    comments: (value: any) => (value ? value : ""),
    lead_status: (value: any) => (value ? getLeadStatus(value) : ""),
  };

  const handleDelete = async (leadId: number) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this lead?"
    );
    if (!confirmDelete) return;

    try {
      deleteLead(leadId); // triggers the saga
      message.success("Lead deleted successfully.");
      setReportsList((prevList) =>
        prevList.filter((record) => record.lead_id !== leadId)
      );
    } catch (err) {
      console.error(err);
      message.error("Failed to delete the lead.");
    }
  };

  const currentYear = new Date().getFullYear(); // 2025
  const lastSixYearsOptions = Array.from({ length: 9 }, (_, i) => {
    const year = currentYear - i; // Start from the previous year
    return { value: String(year), label: String(year) };
  });

  const modalToggle = () => {
    if (showModal) {
      setCurrentLeadId(null);
    }
    setShowModal(!showModal);
  };

  const modalToggeleCleintName = () => {
    setIsShowModalName(!showModalName);
  };

  const adminColumns = [
    // {
    //   title: "Date",
    //   dataIndex: "updated_dt",
    //   key: "updated_dt",
    //   render: (text: any, record: any) => {
    //     return (
    //       <>
    //         {new Date(record?.updated_dt).toLocaleString('en-US', {
    //          year: 'numeric',
    //       month: '2-digit',
    //        day: '2-digit',
    //           hour: '2-digit',
    //           minute: '2-digit',
    //           second: '2-digit',
    //           hour12: true, // Set to false for 24-hour format
    //           timeZone: 'UTC', // Adjust as needed
    //         })}
    //       </>
    //     );
    //   },
    // },

    // {
    //   title: "Date",
    //   dataIndex: "submission_end_datetime",
    //   key: "submission_end_datetime",
    //   render: (text: any, record: any) => {
    //     const dateValue = record?.submission_end_datetime || record?.updated_dt;
    //     return dateValue ? (
    //       <>
    //         {new Date(dateValue).toLocaleString("en-US", {
    //           year: "numeric",
    //           month: "2-digit",
    //           day: "2-digit",
    //           hour: "2-digit",
    //           minute: "2-digit",
    //           second: "2-digit",
    //           hour12: true,
    //           timeZone: "UTC",
    //         })}
    //       </>
    //     ) : (
    //       "N/A"
    //     );
    //   },
    // },

    localUserData?.departmentId === 2 && {
      title: "Date",
      dataIndex: "process_end_datetime",
      key: "process_end_datetime",
      render: (text: any, record: any) => {
        const dateValue = record?.process_end_datetime || record?.updated_dt;
        return dateValue ? (
          <>
            {new Date(dateValue).toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
              timeZone: "UTC",
            })}
          </>
        ) : (
          "N/A"
        );
      },
    },

    localUserData?.departmentId === 3 && {
      title: "Date",
      dataIndex: "verification_end_datetime",
      key: "verification_end_datetime",
      render: (text: any, record: any) => {
        const dateValue =
          record?.verification_end_datetime || record?.updated_dt;
        return dateValue ? (
          <>
            {new Date(dateValue).toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
              timeZone: "UTC",
            })}
          </>
        ) : (
          "N/A"
        );
      },
    },

    localUserData?.departmentId === 4 && {
      title: "Date",
      dataIndex: "review_end_datetime",
      key: "review_end_datetime",
      render: (text: any, record: any) => {
        const dateValue = record?.review_end_datetime || record?.updated_dt;
        return dateValue ? (
          <>
            {new Date(dateValue).toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
              timeZone: "UTC",
            })}
          </>
        ) : (
          "N/A"
        );
      },
    },

    localUserData?.departmentId === 5 && {
      title: "Date",
      dataIndex: "finance_end_datetime",
      key: "finance_end_datetime",
      render: (text: any, record: any) => {
        const dateValue = record?.finance_end_datetime || record?.updated_dt;
        return dateValue ? (
          <>
            {new Date(dateValue).toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
              timeZone: "UTC",
            })}
          </>
        ) : (
          "N/A"
        );
      },
    },

    localUserData?.departmentId === 6 && {
      title: "Date",
      dataIndex: "submission_end_datetime",
      key: "submission_end_datetime",
      render: (text: any, record: any) => {
        const dateValue = record?.submission_end_datetime || record?.updated_dt;
        return dateValue ? (
          <>
            {new Date(dateValue).toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
              timeZone: "UTC",
            })}
          </>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Lead",
      dataIndex: "lead_id",
      key: "lead_id",
      render: (leadId: any) => (
        <span
          onClick={() => {
            setCurrentLeadId(leadId);
            modalToggle();
          }}
        >
          Lead #{leadId}
        </span>
      ),
    },
    {
      title: "ITR Year",
      dataIndex: "itr_year",
      key: "itr_year",
    },
    {
      title: "Client",
      dataIndex: "first_name",
      key: "first_name",
      render: (first_name: any, leadId: any) => (
        <span
          onClick={() => {
            setCurrentLeadId(leadId);
            modalToggeleCleintName();
          }}
        >
          {first_name}
        </span>
      ),
    },
    {
      title: "Email ID",
      dataIndex: "email",
      key: "email",

      render: (email: string) => {
        const cleanEmail = email
          ?.replace(/[^\x20-\x7E]/g, "") // Remove non-ASCII characters
          .trim();
        return cleanEmail;
      },
    },
    {
      title: "Phone",
      dataIndex: "mobile",
      key: "mobile",

      render: (mobile: any) => (
        <a href={`callto:1${mobile}`}>
          <BiSolidPhoneCall size={25} />
        </a>
      ),
    },
    {
      title: "Agent",
      dataIndex: "team_member",
      key: "team_member",
    },
    {
      title: "Source",
      dataIndex: "source",
      key: "source",
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      render: (text: any) =>
        text ? (
          <p
            style={{ margin: 0 }}
            dangerouslySetInnerHTML={{ __html: extractTextFromHTML(text) }}
          />
        ) : (
          "--"
        ),
    },
    {
      title: "Actions",
      key: "action",
      render: (_: any, record: any) => {
        const userDetails = JSON.parse(
          localStorage.getItem("user_details") || "{}"
        );
        const { departmentId, role } = userDetails;
        const isSalesUser = departmentId == 2 && role == 3;

        const leadStatus = record.lead_status;
        const reopenRequest = record.reopen_request;
        return (
          <Space size="middle">
            <span
              onClick={() =>
                navigate(`/leads/edit/${record.lead_id}`, { state: "report" })
              }
            >
              <EyeOutlined style={{ color: "#3AA0E9" }} />
            </span>

            {/* {isSalesUser && (
              <>
                <Button
                  className="slaesButton"
                  style={{ marginLeft: 10 }}
                  onClick={() => {
                    sessionStorage.setItem("clonenewleadid", record.lead_id);
                    navigate(`/leads/create`, {
                      state: { id: record.lead_id },
                    });
                  }}
                >
                  Create Lead
                </Button>

                {leadStatus == 7 &&
                  (reopenRequest == 1 ? (
                    <span style={{ color: "#999" }}>Re-Open Processing</span>
                  ) : (
                    <Checkbox
                      checked={selectedLeadId === record.lead_id}
                      onChange={() =>
                        toggleReopenLeadCheckbox(true, record.lead_id)
                      }
                    >
                      Re-Open
                    </Checkbox>
                  ))}
              </>
            )} */}
          </Space>
        );
      },
    },

    // localUserData?.departmentId === "2" &&
    //   localUserData?.role === "3" && {
    //     title: "Create",
    //     key: "create",
    //     render: (text: any, record: any) => {
    //       const userDetails = JSON.parse(
    //         localStorage.getItem("user_details") || "{}"
    //       );
    //       const { departmentId, role } = userDetails;
    //       return (
    //         <Space size="middle">
    //           {departmentId === 2 &&
    //             role == 3 && ( // Conditionally render the button
    //               <Button
    //                 className="slaesButton"
    //                 style={{ marginLeft: "10px" }}
    //                 onClick={() => {
    //                   sessionStorage.setItem("clonenewleadid", record.lead_id);
    //                   console.log("Lead ID passed:", record.lead_id); // Log the lead ID
    //                   navigate(`/leads/create`, {
    //                     state: { id: record.lead_id },
    //                   });
    //                 }}
    //               >
    //                 Create Lead
    //               </Button>
    //             )}
    //         </Space>
    //       );
    //     },
    //   },
    // {
    //   title: "Reopen",
    //   key: "reopen",
    //   render: (rowItem: any, row: any) => {
    //     const userDetails = JSON.parse(
    //       localStorage.getItem("user_details") || "{}"
    //     );
    //     const { departmentId, role } = userDetails;
    //     return (
    //       <Space size="middle">
    //         <div className="dashboard__header--reopen">
    //           {row.lead_status === "7" && departmentId === 2 && role == 2 && (
    //             <>
    //               <p style={{ fontSize: "small", padding: 0 }}>
    //                 {row.reopen_request === "1" ? (
    //                   "Re-Open Processing"
    //                 ) : (
    //                   <Checkbox
    //                     checked={selectedLeadId === row.lead_id}
    //                     onChange={(e) =>
    //                       toggleReopenLeadCheckbox(true, row.lead_id)
    //                     }
    //                   >
    //                     Re-Open
    //                   </Checkbox>
    //                 )}
    //               </p>
    //             </>
    //           )}
    //         </div>
    //       </Space>
    //     );
    //   },
    // },
  ].filter(Boolean);

  let teamsColumns = [
    // {
    //   title: "Date1",
    //   dataIndex: "department_date",
    //   key: "department_date",
    //   render: (_: any, record: any) => {
    //     const leadStatusToDateFieldMap: Record<number, keyof typeof record> = {
    //       1: "process_start_datetime",
    //       2: "verification_start_datetime",
    //       3: "review_start_datetime",
    //       4: "finance_start_datetime",
    //       5: "submission_start_datetime",
    //       // Extend for other statuses if needed
    //     };

    //     const fieldName = leadStatusToDateFieldMap[record?.lead_status];
    //     const departmentDate = record?.[fieldName];
    //     const fallbackDate = record?.updated_dt;

    //     const finalDate = departmentDate || fallbackDate;

    //     return finalDate ? (
    //       <>
    //         {new Date(finalDate).toLocaleString("en-US", {
    //           year: "numeric",
    //           month: "2-digit",
    //           day: "2-digit",
    //           hour: "2-digit",
    //           minute: "2-digit",
    //           second: "2-digit",
    //           hour12: true,
    //           timeZone: "UTC", // change to local as needed
    //         })}
    //       </>
    //     ) : (
    //       <>N/A</>
    //     );
    //   },
    // },

    {
      title: "Date",
      dataIndex: "submission_end_datetime",
      key: "submission_end_datetime",
      render: (text: any, record: any) => {
        const dateValue = record?.submission_end_datetime || record?.updated_dt;
        return dateValue ? (
          <>
            {new Date(dateValue).toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
              timeZone: "UTC",
            })}
          </>
        ) : (
          "N/A"
        );
      },
    },

    localUserData?.departmentId === 2 && {
      title: "Date",
      dataIndex: "process_end_datetime",
      key: "process_end_datetime",
      render: (text: any, record: any) => {
        const dateValue = record?.process_end_datetime || record?.updated_dt;
        return dateValue ? (
          <>
            {new Date(dateValue).toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
              timeZone: "UTC",
            })}
          </>
        ) : (
          "N/A"
        );
      },
    },

    localUserData?.departmentId === 3 && {
      title: "Date",
      dataIndex: "verification_end_datetime",
      key: "verification_end_datetime",
      render: (text: any, record: any) => {
        const dateValue =
          record?.verification_end_datetime || record?.updated_dt;
        return dateValue ? (
          <>
            {new Date(dateValue).toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
              timeZone: "UTC",
            })}
          </>
        ) : (
          "N/A"
        );
      },
    },

    localUserData?.departmentId === 4 && {
      title: "Date",
      dataIndex: "review_end_datetime",
      key: "review_end_datetime",
      render: (text: any, record: any) => {
        const dateValue = record?.review_end_datetime || record?.updated_dt;
        return dateValue ? (
          <>
            {new Date(dateValue).toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
              timeZone: "UTC",
            })}
          </>
        ) : (
          "N/A"
        );
      },
    },

    localUserData?.departmentId === 5 && {
      title: "Date",
      dataIndex: "finance_end_datetime",
      key: "finance_end_datetime",
      render: (text: any, record: any) => {
        const dateValue = record?.finance_end_datetime || record?.updated_dt;
        return dateValue ? (
          <>
            {new Date(dateValue).toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
              timeZone: "UTC",
            })}
          </>
        ) : (
          "N/A"
        );
      },
    },

    localUserData?.departmentId === 6 && {
      title: "Date",
      dataIndex: "submission_end_datetime",
      key: "submission_end_datetime",
      render: (text: any, record: any) => {
        const dateValue = record?.submission_end_datetime || record?.updated_dt;
        return dateValue ? (
          <>
            {new Date(dateValue).toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
              timeZone: "UTC",
            })}
          </>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "ITR Year",
      dataIndex: "itr_year",
      key: "itr_year",
    },
    {
      title: "Lead",
      dataIndex: "lead_id",
      key: "lead_id",
      render: (leadId: any) => (
        <span
          onClick={() => {
            setCurrentLeadId(leadId);
            modalToggle();
          }}
        >
          Lead #{leadId}
        </span>
      ),
    },
    {
      title: "Agent",
      dataIndex: "team_member",
      key: "team_member",
    },
    {
      title: "Client Name",
      dataIndex: "first_name",
      key: "first_name",
      render: (first_name: any, leadId: any) => (
        <span
          onClick={() => {
            setCurrentLeadId(leadId);
            modalToggeleCleintName();
          }}
        >
          {first_name}
        </span>
      ),
    },
    {
      title: "Email ID",
      dataIndex: "email",
      key: "email",

      render: (email: string) => {
        const cleanEmail = email
          ?.replace(/[^\x20-\x7E]/g, "") // Remove non-ASCII characters
          .trim();
        return cleanEmail;
      },
    },
    {
      title: "Phone",
      dataIndex: "mobile",
      key: "mobile",

      render: (mobile: any) => (
        <a href={`callto:1${mobile}`}>
          <BiSolidPhoneCall size={25} />
        </a>
      ),
    },
    {
      title: "Department",
      dataIndex: "dept_name",
      key: "dept_name",
    },
    {
      title: "Source",
      dataIndex: "source",
      key: "source",
    },
    {
      title: "Status",
      dataIndex: "lead_status",
      key: "lead_status",
      render: (record: any) => (
        <span className={`lead_status status_${record}`}>
          {getLeadStatus(record)}
        </span>
      ),
    },
    {
      title: "Actions",
      key: "action",
      render: (_: any, record: any) => {
        const userDetails = JSON.parse(
          localStorage.getItem("user_details") || "{}"
        );
        const { departmentId, role } = userDetails;

        return (
          <Space size="middle">
            <span
              onClick={() =>
                navigate(`/leads/edit/${record.lead_id}`, { state: "report" })
              }
            >
              <EyeOutlined style={{ color: "#3AA0E9" }} />
            </span>

            {role === "1" && (
              <Popconfirm
                title="Are you sure you want to delete this lead?"
                onConfirm={() => handleDelete(record.lead_id)}
                okText="Yes"
                cancelText="No"
              >
                <span>
                  <DeleteOutlined style={{ color: "red", fontSize: "14px" }} />
                </span>
              </Popconfirm>
            )}
          </Space>
        );
      },
    },
  ].filter(Boolean);

  let roleColumns: any = [
    {
      title: "Federal Count",
      dataIndex: "federal_count",
      key: "federal_count",
    },
    {
      title: "State Count",
      dataIndex: "state_count",
      key: "state_count",
    },
    {
      title: "Local Count",
      dataIndex: "local_count",
      key: "local_count",
    },
    {
      title: "Actual Amount",
      dataIndex: "actual_amount",
      key: "actual_amount",
    },
    {
      title: "Committed Amount",
      dataIndex: "commited_amount",
      key: "commited_amount",
    },
    {
      title: "Actions",
      key: "action",
      render: (_: any, record: any) => {
        return (
          <Space size="middle">
            <span
              onClick={() =>
                navigate(`/leads/edit/${record.lead_id}`, {
                  state: {
                    id: record.lead_id,
                  },
                })
              }
            >
              <EditOutlined style={{ color: "#3AA0E9" }} />
            </span>
          </Space>
        );
      },
    },
  ];

  const fieldsData = [
    {
      label: "ITR Year",
      key: "itrYear",
      elementType: "SELECT",
      onChangeField: () => {},
      options: lastSixYearsOptions,
      required: true,
      disable: false,
      type: "string",
      placeholder: "Select ITR Year",
      config: {
        rules: [{ required: false, message: "Please select ITR Year" }],
      },
    },
    {
      label: "Status",
      key: "status",
      elementType: "SELECT",
      // onChangeField:async (value: any) => await fetchTeamList(value),
      onChangeField: () => {},
      options: statusOptions,
      required: true,
      disable: false,
      type: "string",
      placeholder: "Select status",
      config: {
        rules: [{ required: false, message: "Please select status" }],
      },
    },
    // {
    //   label: "Department",
    //   key: "departmentId",
    //   elementType: "SELECT",
    //   //onChangeField: async (value: any) => await fetchTeamLeadList([localUserData?.departmentId]),
    //   onChangeField: (selectedValue: any) => {
    //     fetchTeamLeadList([selectedValue]);
    //   },
    //   options: departmentOptions,
    //   required: true,
    //   disable: false,
    //   type: "string",
    //   placeholder: "Select Department",
    //   config: {
    //     rules: [{ required: false, message: "Please select status" }],
    //   },
    // },
    {
      label: "Team Lead",
      key: "teamLeadId",
      elementType: "SELECT",
      onChangeField: (selectedValue: any) => {
        fetchTeamList(selectedValue);
      },
      options: teamLeadList,
      required: true,
      disable: false,
      type: "string",
      placeholder: "Select Team Lead",
      config: {
        rules: [{ required: false, message: "Please select Team Lead" }],
      },
    },
    {
      label: "Team",
      key: "teamId",
      elementType: "SELECT",
      onChangeField: (selectedValue: any) => {},
      options: teamList,
      required: true,
      disable: false,
      type: "string",
      placeholder: "Select Team Member",
      config: {
        rules: [{ required: false, message: "Please select Team Member" }],
      },
    },
    {
      label: "Search With Lead Id",
      key: "leadId",
      elementType: "INPUT",
      type: "text",
      placeholder: "Search by Lead id",
      onChangeField: () => {},
    },
    {
      label: "Client Search",
      key: "user",
      elementType: "INPUT",
      required: true,
      disable: false,
      onChangeField: () => {},
      type: "text",
      placeholder: "Search by user name",
      config: {
        rules: [{ required: false, message: "Please Enter user name" }],
      },
    },
    {
      label: "Select Date",
      key: "date",
      elementType: "DATE_PICKER_DATE_RANGE",
      onChangeField: () => {},
      required: true,
      disable: false,
      type: "date",
      value: "",
      config: {
        rules: [{ required: false, message: "Please Enter Date!" }],
      },
    },
    {
      label: "Source",
      key: "source",
      elementType: "SELECT",
      onChangeField: () => {},
      options: sourceOptions,
      required: true,
      disable: false,
      type: "string",
      placeholder: "Select Source",
      config: {
        rules: [{ required: false, message: "Please select Source" }],
      },
    },
  ];

  const getReportsList = async (page: number, query: string | null) => {
    try {
      setIsLoading(true);
      let URL = "";
      if (multiDep !== null && multiDep && localUserData) {
        URL = query
          ? `/dashboard/reports?deptId=${localUserData.departmentId}&page=${
              page + "&" + query
            }`
          : `/dashboard/reports?deptId=${localUserData.departmentId}&page=${page}`;
      } else {
        URL = query
          ? `/dashboard/reports?page=${page + "&" + query}`
          : `/dashboard/reports?page=${page}`;
      }
      const response = await getreportsList(URL);
      if (response) {
        setReportsList(response.data);
        setTotalCount(response.totalRows);
      }
      setIsLoading(false);
    } catch (err: any) {
      setIsLoading(false);
      dispatch(setError({ status: true, type: "error", message: err }));
    }
  };

  const fetchReportsList = async (page: number, query: string | null) => {
    try {
      setIsLoading(true);

      let URL = "";

      if (query) {
        // Include deptId only if role is not 1 and departmentId exists
        if (localUserData.role !== 1 && localUserData.departmentId) {
          URL = `/dashboard/reports?deptId=${localUserData.departmentId}&page=${page}&${query}`;
        } else {
          URL = `/dashboard/reports?page=${page}&${query}`;
        }
      } else {
        // Exclude deptId if role is 1 or departmentId doesn't exist
        if (localUserData.role === 1 || !localUserData.departmentId) {
          URL = `/dashboard/reports?page=${page}`;
        } else {
          URL = `/dashboard/reports?deptId=${localUserData.departmentId}&page=${page}`;
        }
      }

      const response = await getreportsList(URL);

      if (response) {
        setReportsList(response.data || []);
        setTotalCount(response.totalRows || 0);
        setDataLoaded(true); // Set dataLoaded to true after data is fetched
      }

      setIsLoading(false);
    } catch (err: any) {
      setIsLoading(false);
      console.error("Error fetching reports:", err);
      dispatch(setError({ status: true, type: "error", message: err }));
    }
  };

  const fetchTeamLeadList = async (departmentIds: number[]) => {
    try {
      setIsLoading(true);
      const response = await filterTeamLeadByDept({ departmentIds });
      const { data } = response;
      if (data && data.length > 0) {
        setTeamLeadList(
          data?.map((dt: any) => ({
            value: dt.user_id,
            label: `${dt.first_name} ${dt.last_name}`,
          }))
        );
      } else {
        setTeamLeadList([]);
      }
      setIsLoading(false);
    } catch (err: any) {
      setIsLoading(false);
      dispatch(setError({ status: true, type: "error", message: err }));
    }
  };

  // const fetchTeamList = async (value: any) => {
  //   console.log("fetchTeamList")
  //   try {
  //     if (localUserData === null) {
  //       return;
  //     }
  //     const departmentId = value
  //       ? value
  //       : localUserData?.role === "1"
  //       ? 1
  //       : localUserData?.departmentId;
  //     // const response = await getTeamList(
  //     //   `/dashboard/department-wise-team-members?departmentId=${departmentId}`
  //     // );
  //     let response;
  //     if(localUserData?.role === '5'){
  //       response = await getDashboardLeadwiseWiseteammembersDetails(value);
  //     } else {
  //       response = await getTeamList(`/dashboard/department-wise-team-members?departmentId=${departmentId}`);
  //     }

  //     if (response && response.data && Array.isArray(response.data)) {
  //       if (response.data.length > 0) {
  //         const filterData: any[] = [];
  //         setTeamList([]);
  //         response.data.forEach((team: any) => {
  //           if (team?.user_id) {
  //             // Ensure team data is valid
  //             filterData.push({
  //               // label: team.value,
  //               // value: team.user_id
  //               label: localUserData?.role !== "5" ? team?.value : `${team?.first_name} ${team?.last_name}`,
  //               value: team.user_id,
  //             });
  //           }
  //         });
  //         setTeamList(filterData);
  //         setTeamDataLoaded(true);
  //       } else {
  //         // Handle case where data length is 0 or response.data is empty
  //         setTeamList([]);
  //       }
  //     } else {
  //       // Handle case where response or response.data is undefined
  //       setTeamList([]);
  //     }
  //   } catch (err: any) {
  //     setError(err.message || "An error occurred while fetching the team list");
  //     dispatch(
  //       setError({
  //         status: true,
  //         type: "error",
  //         message: err.message || "An error occurred",
  //       })
  //     );
  //   }
  // };

  const fetchTeamList = async (teamLeadId: any, departmentId?: any) => {
    if (!teamLeadId) return;

    setIsLoading(true);
    setIsTeamDropdownDisabled(true);

    try {
      let url = `/team/search-teams?teamLeadId=${teamLeadId}`;
      if (departmentId) {
        url += `&deptId=${departmentId}`;
      }

      const response = await getTeamList(url);

      if (response?.data?.length > 0) {
        const members = response.data.map(
          (member: { first_name: any; last_name: any; user_id: any }) => ({
            label: `${member.first_name} ${member.last_name}`,
            value: member.user_id,
          })
        );
        setTeamList(members);
        setIsTeamDropdownDisabled(false);
      } else {
        setTeamList([]);
      }
    } catch (err) {
      let errorMessage = "An unknown error occurred";

      if (err instanceof Error) {
        errorMessage = err.message;
      }

      dispatch(
        setError({ status: true, type: "error", message: errorMessage })
      );
    } finally {
      setIsLoading(false);
    }
  };

  const generateSearchFields = useMemo(() => {
    let copyFields = fieldsData;

    const role1Fields = [
      "ITR Year",
      "Department",
      "Team Lead",
      "Team",
      "Search With Lead Id",
      "Status",
      "Client Search",
      "Select Date",
      "Source",
    ];
    const role2and5Fields = [
      "ITR Year",
      "Team Lead",
      "Team",
      "Search With Lead Id",
      "Client Search",
      "Select Date",
      "Source",
    ];
    const teamLeadFields = [
      "ITR Year",
      "Team",
      "Search With Lead Id",
      "Client Search",
      "Select Date",
      "Source",
    ];
    const role3ordept_id7Fields = [
      "ITR Year",
      "Client Search",
      "Search With Lead Id",
      "Select Date",
    ];
    const dept9marketing = ["Select Date"];
    //conditions to show the fields
    if (localUserData?.role === "1") {
      copyFields = fieldsData.filter(
        (item) => role1Fields.indexOf(item.label) >= 0
      );
    }
    if (localUserData?.role === "5") {
      copyFields = fieldsData.filter(
        (item) => teamLeadFields.indexOf(item.label) >= 0
      );
    } else if (
      (localUserData?.role === "2" || localUserData?.role === "5") &&
      localUserData?.departmentId !== 9 &&
      localUserData?.departmentId !== 7
    ) {
      copyFields = fieldsData.filter(
        (item) => role2and5Fields.indexOf(item.label) >= 0
      );
    } else if (
      localUserData?.role === "3" ||
      localUserData?.departmentId === 7
    ) {
      copyFields = fieldsData.filter(
        (item) => role3ordept_id7Fields.indexOf(item.label) >= 0
      );
    } else if (localUserData?.departmentId === 9) {
      copyFields = fieldsData.filter(
        (item) => dept9marketing.indexOf(item.label) >= 0
      );
    }
    return copyFields;
  }, [teamList, teamLeadList]);

  useEffect(() => {
    if (localUserData?.departmentId !== 8 || isSearched) {
      fetchReportsList(currentPage, queryString);
    }
  }, [currentPage, queryString, isSearched, dataLoaded]);

  useEffect(() => {
    if (localUserData) {
      if (localUserData?.role !== "1") {
        if (localUserData?.departmentId && localUserData?.departmentId === 8) {
          setTableColumns(
            adminColumns.filter(
              (_: any, i: number) => i !== adminColumns.length - 1
            )
          );
        } else {
          if (
            localUserData?.departmentId &&
            localUserData?.departmentId === 9 &&
            localUserData?.role === "2"
          ) {
            const newConditions = ["Lead", "Comments", "Actions"];
            // const newadminColumns = adminColumns.filter(
            //   (item) => newConditions.indexOf(item.title) === -1
            // );
            // setTableColumns(newadminColumns);
          } else {
            const newConditions = ["Actions"];
            // const newadminColumns = adminColumns.filter(
            //   (item) => newConditions.indexOf(item.title) === -1
            // );
            if (localUserData?.departmentId === 7) {
              setTableColumns(adminColumns);
            } else {
              setTableColumns(adminColumns);
            }
          }
        }
      } else {
        if (
          localUserData?.role === "3" &&
          (localUserData?.departmentId === 4 ||
            localUserData?.departmentId === 5)
        ) {
          setTableColumns(teamsColumns.concat(roleColumns));
        } else {
          setTableColumns(teamsColumns);
        }
      }
    }
  }, [teamDataLoaded]);

  const userData = localStorageContent.getUserData();

  useEffect(() => {
    if (localUserData?.role === "5") {
      fetchTeamList(userData?.userId);
    } else {
      fetchTeamList(null);
    }
  }, []);

  useEffect(() => {
    if (
      localUserData &&
      localUserData.role !== "1" &&
      localUserData.role !== "3"
    ) {
      fetchTeamLeadList([localUserData?.departmentId]);
    }
    fetchTeamList(null);
  }, []);

  return (
    <div>
      {showModal && (
        <History
          show={showModal}
          hideModal={modalToggle}
          leadId={currentLeadId}
          setCurrentLeadId={setCurrentLeadId}
          isLeads={true}
        />
      )}
      {showModalName && (
        <LeadHistory
          show={showModalName}
          hideModal={modalToggeleCleintName}
          leadId={currentLeadId}
          setCurrentLeadId={setCurrentLeadId}
        />
      )}
      <ContentHeader
        showBtn={false}
        redirectPath="/reports"
        buttonText=""
        title="Reports"
        showIcon
        Icon={FiPlusCircle}
      />
      <SearchFilter
        fields={generateSearchFields}
        onSubmit={(queryStrings: any) => {
          setCurrentPage(1);
          setQueryString(queryStrings);
          if (localUserData?.departmentId === 7) {
            setIsSearched(true);
          }
        }}
        clearSearch={() => {
          setCurrentPage(1);
          setQueryString(null);
          if (localUserData?.departmentId === 7) {
            setIsSearched(false);
            setReportsList([]);
          }
        }}
        showButtons={true}
      />
      {localUserData &&
        (localUserData?.role === "1" ||
          (localUserData?.departmentId === 9 &&
            localUserData?.role === "2")) && (
          <div>
            <DownloadCsv
              disabled={false}
              headers={tableColumns.map((col: any) => ({
                title: col.title,
                key: col.key,
                formate: col?.render ? exportFormates[col.key] : false,
              }))}
              filename={"Reports"}
              URL={
                queryString
                  ? `/dashboard/reports?download=1&${queryString}`
                  : "/dashboard/reports?download=1"
              }
            />
          </div>
        )}
      {reportsList.length > 0 && (
        <>
          <Table
            rowClassName="editable-row"
            bordered
            columns={tableColumns}
            dataSource={
              localUserData?.departmentId === 7 && !isSearched
                ? []
                : reportsList
            }
            pagination={false}
            loading={isLoading}
          />
          <Pagination
            onChange={(pagination: any) => {
              setCurrentPage(pagination);
            }}
            style={{ marginTop: "15px" }}
            current={currentPage}
            defaultPageSize={25}
            showSizeChanger={false}
            hideOnSinglePage
            total={totalCount}
          />
        </>
      )}
      <ReopenLead
        isChecked={checkedReopenLead}
        leadId={selectedLeadId}
        toggleReopenLeadCheckbox={() => toggleReopenLeadCheckbox(false, null)}
      />
    </div>
  );
};

export default Reports;
